<template>
  <page-header :title="'Проект ' + project_id" icon="bi-gear-wide" :back="true"/>
  <f-loader ref="loader">
    <simple-table
        :format="[
            ['title'],
            ['info'],
        ]"
        :items="projectInfo"
        :no-header="true"
    />
    <simple-table
        class="mt-3"
        title="Установки"
        :format="[
            ['target_url', 'URL'],
            ['provisioned_by', 'Кем', i=>users[i.provisioned_by] || i.provisioned_by],
            ['provisioned_at', 'Когда', i=>format_datetime(new Date(i.provisioned_at * 1000))],
            ['meta', 'Метаинформация', i=>i.meta?JSON.stringify(i.meta):'Нет'],
            ['', '', i=>'<i class=\'bi bi-x\'/>'],
        ]"
        :items="provisionRecords"
        :select="i=>i.index==0"
        :search="true"
        :page-size="5"
        @click-item="onUnprovision"
        :buttons="provisionButtons"
        @click-button="onClickButton"
    />
    <std-table
        v-if="project?.nlu?.nlu_kind=='interpreter'"
        class="mt-3"
        :format="[
        ['script_id','ID'],
        ['name','Название'],
      ]"
        :url="'/myprojects/'+project_id+'/scripts'"
        resource="script"
        :params="{project_id: project_id}"

        title="Сценарии"
        button="Создать сценарий"
        :more-buttons="[{id:'show', button:showProvisioned?'Скрыть установленные':'Показать установленные'}]"
        @click-button="showProvisioned=!showProvisioned"
        :items-filter="i=>showProvisioned || !i.readonly"
    />
  </f-loader>
</template>

<script>
import PageHeader from "@/components/PageHeader";
import FLoader from "@/components/FLoader";
import {http} from "@/misc/http";
import SimpleTable from "@/components/simple-table/SimpleTable";
import StdTable from "@/components/StdTable";
import {format_datetime} from "@/misc/util";

export default {
  components: {StdTable, SimpleTable, FLoader, PageHeader},
  props: ["project_id"],
  data() {
    return {
      showProvisioned: false,
      project: {},
      users: {},
    }
  },

  async mounted() {
    await this.$refs.loader.wrap(async () => {
      this.project = await http.get("/myprojects/" + this.project_id);
      this.users = (await http.get("/profile/all")).reduce(
          (acc, user) => ({...acc, ...{[user.login]: user.name}}),
          {}
      );
    });

  },

  computed: {
    projectInfo() {
      const nlu = this.project.nlu;
      const tgbot = this.project.tgbot;
      const maxbot = this.project.maxbot;
      const http_ep_config = this.project.http_ep_config;
      return [
        {title: 'ID проекта', info: this.project_id},
        {title: 'Описание', info: this.project.description},
        {title: 'NLU', info: nlu ? `${nlu.name} - ${nlu.description}` : 'Нет'},
        {title: 'Телеграм бот', info: tgbot ? `${tgbot.name} - ${tgbot.description} <a target="_blank" href='https://t.me/${tgbot.bot_username}'>@${tgbot.bot_username}</a>` : 'Нет'},
        {title: 'Макс бот', info: maxbot ? `${maxbot.name} - ${maxbot.description} <a target="_blank" href='https://max.ru/${maxbot.bot_username}'>@${maxbot.bot_username}</a>` : 'Нет'},
        {title: 'Конфигурация HTTP ендпоинта', info: http_ep_config ? `${http_ep_config.name} - ${http_ep_config.description}` : 'Нет'},
      ]
    },
    provisionRecords() {
      return this.project?.provision_records?.map((item, index) => ({index: index, ...item})) || [];
    },
    provisionButtons() {
      const res = [];

      if (this.project?.provision_records?.length)
        res.push({id: "connect", button: "Подключиться к проекту"});

      if (this.project?.nlu?.nlu_kind == "generic") {
        res.push({id: "test", button: "Тестировать"});
        res.push({id: "provision", button: "Установить", class: 'btn-warning'});
      }

      return res;
    },
  },

  methods: {
    async onUnprovision(provision_record) {
      if (!confirm(
          "Вы собираетесь удалить установочную запись и ассоциированный с ней служебный сценарий. " +
          (provision_record.index == 0 ?
                  "Запись является активной, то есть обслуживает все новые сессии проекта. "
                  :
                  "Запись не является активной, но может обслуживать старые сессии. "
          ) +
          "Вы уверены?"
      )) return;
      await this.$refs.loader.wrap(async () => {
        await http.delete("/myprojects/" + this.project_id + "/provision/" + provision_record.index);
      });
      this.$router.go();
    },

    async onClickButton(button) {
      switch (button.id) {
        case "connect":
          window.open('/u/' + this.project_id + '/' + this.project_id + '?reset=1', "_blank");
          break;
        case "test":
        case "provision": {
          const test_mode = button.id == 'test';

          if (!test_mode && !confirm(
              "Вы собираетесь установить NLU в продакшн. " +
              "Это повлияет на весь последующий трафик проекта " + this.project_id + ". " +
              "Вы уверены?")) return;

          if (await this.$refs.loader.wrap(async () => {
            await http.post("/myprojects/" + this.project_id + "/provision", {
              test_mode: test_mode,
            });
          })) {
            if (test_mode) {
              const pid = this.project_id + "-test";
              window.open('/u/' + pid + '/' + pid + '?reset=1', "_blank");
            } else this.$router.go();
          }
        }
      }
    },
    format_datetime,
  },


}
</script>

